var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNofoundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0519 18.0524L25.6769 25.6774M25.6769 18.0524L18.0519 25.6774M34.9362 35.0053L42.7645 42.8337M40.2915 21.2295C40.2915 26.2852 38.2831 31.1338 34.7082 34.7087C31.1333 38.2836 26.2847 40.292 21.229 40.292C16.1733 40.292 11.3247 38.2836 7.74978 34.7087C4.17487 31.1338 2.1665 26.2852 2.1665 21.2295C2.1665 16.1738 4.17487 11.3252 7.74978 7.75027C11.3247 4.17536 16.1733 2.16699 21.229 2.16699C26.2847 2.16699 31.1333 4.17536 34.7082 7.75027C38.2831 11.3252 40.2915 16.1738 40.2915 21.2295Z",
    stroke: "#5070DE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofoundIcon);
export default __webpack_public_path__ + "static/media/nofoundIcon.351bbad1a5b23dde75188500436c25cf.svg";
export { ForwardRef as ReactComponent };